// Mock data for Hire Me Studio Portfolio

export const NAV_LINKS = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Process", href: "#process" },
  { label: "Contact", href: "#contact" },
];

const u = (id, w = 600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=70`;

export const HERO_IMAGES = {
  inline1: u("photo-1586880244406-556ebe35f282", 500),
  inline2: u("photo-1499951360447-b19be8fe80f5", 400),
  inline3: u("photo-1507003211169-0a1dd7228f2d", 300),
  avatars: [
    u("photo-1629425733761-caae3b5f2e50", 100),
    u("photo-1627161683077-e34782c24d81", 100),
    u("photo-1573496359142-b8d87734a5a2", 100),
  ],
};

export const HERO_GRID = {
  far_left: { image: u("photo-1522202176988-66273c2fd55f", 500), color: "bg-[#F97316]", label: "Team work" },
  left: [
    { image: u("photo-1460925895917-afdab827c52f", 500), color: "bg-[#3B82F6]", label: "Analytics" },
    { image: u("photo-1556742049-0cfed4f6a45d", 500), color: "bg-[#FFE14D]", label: "Checkout" },
  ],
  center: { image: "/images/profile.png", color: "bg-[#FFE14D]", label: "Prince · Founder" },
  right: [
    { image: u("photo-1523275335684-37898b6baf30", 500), color: "bg-[#F97316]", label: "Products" },
    { image: u("photo-1498050108023-c5249f4df085", 500), color: "bg-[#3B82F6]", label: "Clean code" },
  ],
  far_right: { image: u("photo-1441986300917-64674bd600d8", 500), color: "bg-[#22C55E]", label: "Storefront" },
};

export const HERO_QUOTE =
  "I'm very much of the 'build less but build better' persuasion every site I ship has one job: turn visitors into customers.";

export const MARQUEE_ITEMS = [
  "WordPress",
  "Shopify",
  "WooCommerce",
  "Elementor",
  "Liquid",
  "PHP",
  "JavaScript",
  "Tailwind CSS",
  "Figma",
  "SEO Optimized",
];

export const STATS = [
  { value: "120+", label: "Projects Delivered", color: "bg-[#3B5BDB] text-white", icon: "Rocket", trend: "+18 this year" },
  { value: "5", label: "Years of Craft", color: "bg-[#F97316] text-white", icon: "Hourglass", trend: "since 2019" },
  { value: "48", label: "Happy Clients", color: "bg-[#B7F0BE] text-black", icon: "HeartHandshake", trend: "5.0 ★ average" },
  { value: "5", label: "Countries Served", color: "bg-[#FFE14D] text-black", icon: "Globe2", trend: "4 continents" },
];

export const ABOUT_TILES = {
  center: { image: "/images/profile.png", color: "bg-[#FFE14D]" },
  left: [
    { image: u("photo-1519389950473-47ba0277781c", 500), color: "bg-[#F97316]" },
    { image: u("photo-1531973576160-7125cd663d86", 500), color: "bg-[#8B5CF6]" },
  ],
  right: [
    { image: u("photo-1552664730-d307ca884978", 500), color: "bg-[#0A5C36]" },
    { image: u("photo-1581091226825-a6a2a5aee158", 500), color: "bg-[#3B82F6]" },
  ],
  stat: u("photo-1542744173-8e7e53415bb0", 700),
};

export const ABOUT_QUOTE =
  "I'm very much of the 'ship fast, polish harder' persuasion. A website should look premium on day one and keep converting on day one hundred.";

export const SERVICES = [
  {
    id: 1,
    tag: "Beginner",
    title: "WordPress Development",
    subtitle: "2 years min. of dedicated craft",
    desc: "Custom WordPress themes, page builders, and blazing-fast CMS websites tailored to your brand.",
    bullets: ["Custom Themes", "Elementor / Divi", "Speed & SEO", "Maintenance"],
    color: "bg-[#B7F0BE]",
    image:
      "https://images.unsplash.com/photo-1522071901873-411886a10004?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHx5b3VuZyUyMHBlb3BsZSUyMHdvcmtpbmclMjBsYXB0b3B8ZW58MHx8fHwxNzg5MTQ3MTQ0fDA&ixlib=rb-4.1.0&q=70&w=600",
  },
  {
    id: 2,
    tag: "Popular",
    title: "Shopify Stores",
    subtitle: "3+ years of ecommerce work",
    desc: "Beautiful, conversion-focused Shopify stores with Liquid customization and 3rd party integrations.",
    bullets: ["Theme Customization", "Product Setup", "Payment Gateways", "Apps & Automations"],
    color: "bg-[#FDB679]",
    image:
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHx5b3VuZyUyMHBlb3BsZSUyMHdvcmtpbmclMjBsYXB0b3B8ZW58MHx8fHwxNzg5MTQ3MTQ0fDA&ixlib=rb-4.1.0&q=70&w=600",
  },
  {
    id: 3,
    tag: "Advanced",
    title: "WooCommerce",
    subtitle: "Multi-vendor & complex flows",
    desc: "Dynamic & static WooCommerce stores – from single-product landings to full multi-vendor setups.",
    bullets: ["Dynamic Products", "Checkout Flow", "Multi-currency", "Analytics"],
    color: "bg-[#B4D6F7]",
    image:
      "https://images.unsplash.com/photo-1543269865-0a740d43b90c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHx5b3VuZyUyMHBlb3BsZSUyMHdvcmtpbmclMjBsYXB0b3B8ZW58MHx8fHwxNzg5MTQ3MTQ0fDA&ixlib=rb-4.1.0&q=70&w=600",
  },
  {
    id: 4,
    tag: "Growth",
    title: "Speed & SEO",
    subtitle: "Rank higher, load faster",
    desc: "Turn slow, forgotten sites into fast, discoverable stores that actually rank on Google.",
    bullets: ["Core Web Vitals", "On-page SEO", "Schema", "Analytics setup"],
    color: "bg-[#E9C3F5]",
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHx0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3ODkxNDcxNDR8MA&ixlib=rb-4.1.0&q=70&w=600",
  },
];

export const HIGHLIGHTS = [
  {
    kind: "chart",
    color: "bg-[#B7F0BE]",
    metric: "+62%",
    metricLabel: "Avg. conversion lift",
    title: "Boost your store's conversions",
    image: u("photo-1460925895917-afdab827c52f", 800),
  },
  {
    kind: "logos",
    color: "bg-neutral-950 text-white",
    title: "Built with the best in the game.",
    tools: ["WordPress", "Shopify", "WooCommerce", "Elementor", "Liquid", "Figma"],
    image: u("photo-1498050108023-c5249f4df085", 800),
  },
  {
    kind: "clients",
    color: "bg-[#FFE14D]",
    title: "Join 48+ founders who trust me.",
    ctaLabel: "Start Now",
    image: u("photo-1522071820081-009f0129c71c", 800),
  },
];

// Real client projects
const shot = (u) =>
  `https://image.thum.io/get/width/900/crop/700/noanimate/${u}`;

export const PROJECTS = [
  {
    id: 1,
    title: "Focus On Road",
    category: "WordPress · Driving School",
    location: "Berwick, Australia",
    year: "2025",
    url: "https://focusonroad.com.au",
    image: "/images/focusonroad.png",
    color: "bg-[#B7F0BE]",
  },
  {
    id: 2,
    title: "WeCan Consultancy",
    category: "WordPress · Leadership Coaching",
    location: "Bengaluru, India",
    year: "2025",
    url: "https://wecanconsultancy.com",
    image: shot("https://wecanconsultancy.com"),
    color: "bg-[#FDB679]",
  },
  {
    id: 3,
    title: "OpsManager",
    category: "WordPress · Enterprise SaaS",
    location: "Global",
    year: "2024",
    url: "https://www.opsmanager.com",
    image: "/images/opsmanager-thumb-img.png",
    color: "bg-[#B4D6F7]",
  },
  {
    id: 4,
    title: "i2 Spa Indore",
    category: "WordPress · Luxury Wellness",
    location: "Indore, India",
    year: "2025",
    url: "https://i2spaindore.in",
    image: "/images/i2spa-thumb-img.png",
    color: "bg-[#E9C3F5]",
  },
  {
    id: 5,
    title: "Hygienic Dental Clinic",
    category: "WordPress · Dental Care",
    location: "Dubai, UAE",
    year: "2025",
    url: "https://hygienicdentalclinic.com",
    image: "/images/hygien-thumb-img.png",
    color: "bg-[#FFE14D]",
  },
  {
    id: 6,
    title: "MoveMitra",
    category: "WordPress · CRM for Movers",
    location: "India",
    year: "2024",
    url: "https://movemitra.com",
    image: "/images/movemitra-thumb-img.png",
    color: "bg-[#FCA5A5]",
  },
  {
    id: 7,
    title: "Photosafaris",
    category: "WordPress · Travel & Tours . Jet Engine",
    location: "Australia",
    year: "2025",
    url: "https://behzadl2.sg-host.com/photosafaris/",
    image: "/images/photosafaris.png",
    color: "bg-[#FCA5A5]",
  },
   {
    id: 8,
    title: "Amber Healing Centre",
    category: "WordPress · Wellness & Spa",
    location: "Australia",
    year: "2025",
    url: "https://amberhealingcentre.com.au/",
    image: "/images/amber.png",
    color: "bg-[#FCA5A5]",
  },
  
];

export const PROCESS = [
  {
    step: "01",
    title: "Discovery Call",
    desc: "We hop on a quick call, understand your brand, goals and target audience.",
  },
  {
    step: "02",
    title: "Design & Wireframe",
    desc: "I craft wireframes and design mockups in Figma before writing a single line of code.",
  },
  {
    step: "03",
    title: "Development",
    desc: "Pixel-perfect coding on WordPress / Shopify / WooCommerce with clean structure.",
  },
  {
    step: "04",
    title: "Launch & Support",
    desc: "We go live, hand over the keys, and I stay around for a month of free tweaks.",
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Rajesh K.",
    role: "Founder, Focus On Road · Australia",
    avatar:
      "https://images.unsplash.com/photo-1629425733761-caae3b5f2e50?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3ODY0MjE0NzR8MA&ixlib=rb-4.1.0&q=70&w=600",
    quote:
      "Prince rebuilt our driving school website from the ground up. Bookings jumped almost immediately and the site actually reflects the quality of our lessons.",
  },
  {
    id: 2,
    name: "Jithuu Sangram",
    role: "Founder, WeCan Consultancy · Bengaluru",
    avatar:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3ODY0MjE0NzR8MA&ixlib=rb-4.1.0&q=70&w=600",
    quote:
      "Detail-oriented, calm and quick. Prince translated our whole leadership philosophy into a site that finally feels like us. Highly recommended.",
  },
  {
    id: 3,
    name: "Dr. Neha Sachdeva",
    role: "Manager, Hygienic Dental Clinic · Dubai",
    avatar:
      "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3ODY0MjE0NzR8MA&ixlib=rb-4.1.0&q=70&w=600",
    quote:
      "Our new website looks premium, loads fast and patients now book online without calling. Exactly what we needed.",
  },
];

export const FAQS = [
  {
    q: "How long does a typical project take?",
    a: "A landing page takes 5–7 days. A full WordPress or Shopify store usually takes 3–5 weeks depending on the scope.",
  },
  {
    q: "Do you work with clients outside India?",
    a: "Absolutely. I've worked with clients in Australia, UAE, US, UK and Canada. Async-friendly and timezone flexible.",
  },
  {
    q: "Will my site be mobile responsive?",
    a: "Every site I ship is fully responsive, fast, and optimized for Core Web Vitals — mobile-first, always.",
  },
  {
    q: "Do you offer maintenance after launch?",
    a: "Yes. First month of tweaks and bug-fixes is free. After that, I offer monthly retainers starting at ₹7,499.",
  },
];
